import type { CanonicalUserRecord } from '@responses/users';

import type { UserCapabilitiesManager } from './types';
import { CognitoUserStatus, UserLifeCycleStatus } from './types';
export class UserCapabilityManager implements UserCapabilitiesManager {
  constructor(private readonly user: CanonicalUserRecord) {}

  get canBeEdited() {
    return this.user.status !== CognitoUserStatus.ForceChangePassword;
  }

  get canBeResentInvite() {
    return this.user.status === CognitoUserStatus.ForceChangePassword;
  }

  get canBeRemoved() {
    return getUserLifeCycleStatus(this.user) === UserLifeCycleStatus.Pending;
  }

  get canBeUpdatedAsPended() {
    return this.canBeResentInvite || this.canBeRemoved;
  }

  get canBeEnabledOrDisabled() {
    return getUserLifeCycleStatus(this.user) !== UserLifeCycleStatus.Pending;
  }

  get userLifeCycleStatus() {
    return getUserLifeCycleStatus(this.user);
  }
}

export function getUserLifeCycleStatus(
  user: Pick<CanonicalUserRecord, 'status' | 'enabled' | 'isDraftUserRecord'>,
): UserLifeCycleStatus {
  if (
    user.enabled &&
    [CognitoUserStatus.Confirmed, CognitoUserStatus.ExternalProvider].includes(user.status as CognitoUserStatus) &&
    !user.isDraftUserRecord
  ) {
    return UserLifeCycleStatus.Active;
  }

  if (user.status === CognitoUserStatus.ForceChangePassword || user.isDraftUserRecord) {
    return UserLifeCycleStatus.Pending;
  }

  if (user.enabled === false) {
    return UserLifeCycleStatus.Disabled;
  }

  if (user.status === CognitoUserStatus.ResetRequired) {
    return UserLifeCycleStatus.ResetRequired;
  }

  return UserLifeCycleStatus.Disabled;
}
